<template>
  <!--
    ปุ่มค้นหาเครื่องพิมพ์ USB / Bluetooth — ใช้ทั้งหน้าจอเริ่มต้น (ยังไม่มีเครื่อง) และแผง "เปลี่ยนเครื่อง"
    ปุ่มแรกเป็นปุ่มหลัก (USB มาก่อน: เร็ว/เสถียรกว่า) · ปุ่มที่กดไม่ได้ (PC ไม่มี Bluetooth) ยังโชว์
    พร้อมบอกเหตุผล — ซ่อนเฉย ๆ คนจะหาไม่เจอว่าทำไมไม่มีให้เลือก
  -->
  <div>
    <div class="d-flex flex-wrap justify-content-center gap-2">
      <button
        v-for="(opt, i) in options"
        :key="opt.kind"
        type="button"
        class="btn rounded-3 fw-semibold"
        :class="[i === 0 ? 'btn-theme' : 'btn-outline-theme', small ? 'btn-sm px-3' : 'px-3']"
        :disabled="busy || opt.disabled"
        @click="$emit('find', opt.kind)"
      >
        <i :class="opt.icon" class="me-2"/>{{ $t(opt.label) }}
      </button>
    </div>
    <div v-if="options.some(o => o.disabled)" class="small text-muted mt-2">
      <i class="fa-brands fa-bluetooth-b me-1"/>{{ $t('_printer.This computer has no Bluetooth or it is turned off') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FindPrinterButtons',
  emits: ['find'],
  props: {
    // [{ kind: 'usb'|'bluetooth', icon, label, disabled }]
    options: { type: Array, default: () => [] },
    busy: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
  },
};
</script>
